import type { StandType } from '@stageplottter/core';
import { Link2 } from 'lucide-react';

/**
 * Small pictograms of the stand types (U68), drawn like a side view: base, pole, boom. They tell a
 * stand TYPE apart from a shared, concrete stand (link icon, {@link ShareIcon}).
 */
const PATHS: Record<StandType, string> = {
  straight: 'M8 2v10M4 15l4-3 4 3',
  boom: 'M8 6v6M4 15l4-3 4 3M8 6l5-4',
  telescopic_boom: 'M8 5v7M4 15l4-3 4 3M8 5l6-4M11 3l1 .8',
  short_boom: 'M8 9v3M4 15l4-3 4 3M8 9l5-3',
  desk: 'M8 8v6M4 14.5h8',
  clamp: 'M5 4h6v4H5zM8 8v6M6 14h4',
  overhead: 'M5 4v8M2 15l3-3 3 3M5 4l9-2',
  speaker_stand: 'M8 6v6M4 15l4-3 4 3M5 1h6v5H5z',
  lighting_stand: 'M8 3v9M4 15l4-3 4 3M4 3h8',
  truss_lift: 'M8 4v8M4 15l4-3 4 3M3 2h10v2H3z',
};

export function StandIcon({ type, size = 16 }: { type: StandType; size?: number }) {
  return (
    <svg
      className="stand-icon"
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.4}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d={PATHS[type]} />
    </svg>
  );
}

export function ShareIcon({ size = 16 }: { size?: number }) {
  return <Link2 className="stand-icon" size={size} aria-hidden="true" />;
}

/** Icon of a grid option / cell: `stand:<type>` or `share` (U68). */
export function GridIcon({ icon }: { icon: string }) {
  if (icon === 'share') return <ShareIcon size={14} />;
  const type = icon.startsWith('stand:') ? (icon.slice(6) as StandType) : undefined;
  return type !== undefined && type in PATHS ? <StandIcon type={type} size={14} /> : null;
}
